export enum DashboardNodeType {
  CONTAINER = 'ak-dashboard-node-container',
  NAVIGATION = 'ak-dashboard-node-navigation',
  LAYOUT = 'ak-dashboard-node-layout',
  COLLAPSE = 'ak-dashboard-node-collapse',
  WIDGET = 'ak-dashboard-node-widget',
}
